// Import our CSS
import "@/scss/glightbox.scss";

import GLightbox from "glightbox";

const experienceFormLightbox = GLightbox({
    closeButton: true,
    selector: null,
    skin: "form-wrapper glightbox-clean",
    width: "min(100%, 36rem)",
    height: "min(90vh, 52rem)",
});

document.addEventListener("DOMContentLoaded", function () {
    let lightboxElements = document.querySelectorAll('.glightbox');
    lightboxElements.forEach(element => {
        let box = GLightbox({
            selector: "#" + element.getAttribute('id'),
        });

        box.on('open', () => {
            setTimeout(function() {
                if(document.querySelector(".ginner-container").querySelector('form.fui-form')) {
                    window.Formie.initForms();
                }
            }, 50);
        });
    });

    let experienceForms = document.querySelectorAll(".glightbox-popup-form");
    experienceForms.forEach(element => {
        let apiForm = element.getAttribute("data-apiForm");
        element.addEventListener('click', function(e) {
            e.preventDefault();
            let paragraphText = element.querySelector(".p-txt");
            let paragraphLoader = element.querySelector(".p-loader");

            if (paragraphText) {
                paragraphText.style.display = "none";
            }

            if (paragraphLoader) {
                paragraphLoader.style.display = "inline-block";
            }

            const eventUid = element.getAttribute("data-event");
            const formUid = element.getAttribute("data-form");
            const embedUrl = new URL("/apis/" + apiForm, window.location.origin);
            embedUrl.searchParams.set("event", eventUid);
            embedUrl.searchParams.set("form", formUid);
            embedUrl.searchParams.set("embed", "1");

            const resetTrigger = () => {
                if (paragraphText) {
                    paragraphText.style.display = "inline-block";
                }
                if (paragraphLoader) {
                    paragraphLoader.style.display = "none";
                }
            };

            experienceFormLightbox.once("open", resetTrigger);
            experienceFormLightbox.setElements([{
                href: embedUrl.toString(),
                type: "external",
            }]);
            experienceFormLightbox.open();
        });
    });
});
